import {Component, OnInit} from '@angular/core';
import {ClassificatorEditModalComponent} from '../classificator-edit-modal/classificator-edit-modal.component';
import {ControlContainer, NgForm} from '@angular/forms';
import {SelectComponent} from '../../../core/components/edit-component';
import {ClassificatorQuery} from 'common-shared';

@Component({
  selector: 'mes-web-classificator-select',
  templateUrl: './classificator-select.component.html',
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class ClassificatorSelectComponent extends SelectComponent<ClassificatorQuery> implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {
    this.refreshToken$.next(undefined);
  }

  editClassificator() {
    this.modalService.show(ClassificatorEditModalComponent, {initialState: {classificatorId: this.entityId}, class: "modal-lg"}).onHide$.subscribe((bsModalRef) => {
      this.setEntityId(bsModalRef.content.classificatorId);
    });
  }

  addNewClassificator(searchTerm: string = null) {
    const modalRef = this.modalService.show(ClassificatorEditModalComponent, {initialState: {classificatorName: searchTerm}, class: "modal-lg"});
    modalRef.onHide$.subscribe((bsModalRef) => {
      this.setEntityId(bsModalRef.content.classificatorId);
    });
  }
}
